import selectors from '../../../../rootSelectors';
import {
    goToQuestion,
    goToInterstitial,
    goToStartPage,
} from '../../../../common/navigation/navigationActions';
import { blockScreen, unblockScreen, deactivateNextButton }
    from '../../../../common/screen/screenActions';
import { narrateStart, narrateReset } from '../../../../common/audio/audioActions';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import { saveMeasureResponse } from '../../../../common/api/vocabActions';
import VocaboServiceClient from '../../../../common/clients/VocaboServiceClient';
import { autoplayScript } from '../../vocabFITBActions';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { VOCAB } from '../../../../constants/measure';
import { FITB_GRADES_WITH_INTERSTITIAL } from '../../../vocabConstants';
import { startQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';

export const narrateQuestionsScreen = (questionIndex, stimulusAudio) => async (dispatch) => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(autoplayScript(questionIndex, stimulusAudio, QUESTIONS));
    dispatch(narrateReset());
    dispatch(unblockScreen());
    dispatch(startQuestionTimeTracking());
};

export const saveFITBResponse = (response, questionIndex, isLastQuestion) => (dispatch, getStore) => {
    const state = getStore();
    const { itemId } = selectors.getVocabFITBContent(state, QUESTIONS, questionIndex);
    const formId = selectors.getVocabFITBFormId(state);
    const language = selectors.getCurrentLanguage(state);
    const responseId = selectors.getVocabFITBSelectedResponseId(
        state,
        QUESTIONS,
        questionIndex,
        response,
    );

    return dispatch(saveMeasureResponse(
        VocaboServiceClient.MEASURES.FITB,
        itemId,
        questionIndex,
        formId,
        language,
        responseId,
        isLastQuestion,
    ));
};

export const onNextQuestionButtonClick = (response, questionIndex) => (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);
    const language = selectors.getCurrentLanguage(state);
    const isLastQuestion = (
        questionIndex === selectors.getVocabFITBTotalQuestions(state)
    );

    dispatch(blockScreen());

    return dispatch(saveFITBResponse(response, questionIndex - 1, isLastQuestion))
        .then(() => {
            const nextQuestion = questionIndex + 1;

            if (isLastQuestion) {
                dispatch(setPlaylistItemCompleted(VOCAB.FITB, language));

                if (FITB_GRADES_WITH_INTERSTITIAL.includes(grade)) {
                    return dispatch(goToInterstitial());
                }

                return dispatch(goToStartPage());
            }

            dispatch(unblockScreen());
            dispatch(deactivateNextButton());
            dispatch(resetQuestionsAndTimeTrackingState());

            return dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB.FITB, nextQuestion));
        });
};
